module.exports = __webpack_public_path__ + "media/public/images/about/head-57e18335ce7c3128c111ed499ccd2b85.jpg";